import React from "react";

function DobbleCheck({ width = 20, height = 20, fill = "#F8F6F6" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_93155)">
        <path
          d="M15.0001 5.8332L13.8251 4.6582L8.5418 9.94154L9.7168 11.1165L15.0001 5.8332ZM18.5335 4.6582L9.7168 13.4749L6.23346 9.99987L5.05846 11.1749L9.7168 15.8332L19.7168 5.8332L18.5335 4.6582ZM0.341797 11.1749L5.00013 15.8332L6.17513 14.6582L1.52513 9.99987L0.341797 11.1749Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_93155">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DobbleCheck;
